export default __webpack_public_path__ + "static/commercial_b.2707b6f2c4659bd57c1fb38b36f6bcf7.svg";